import React, { useState } from 'react';
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';

const PayPalPayment = ({ token, amount, course_id, membership_id }) => {
  // const { token } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handlePaymentSuccess = async (details, data ) => {
    
    setLoading(true);
    setError(null);
// console.log('Token detailsssssss:', token?.course_id);

    try {
      if (details.status === 'COMPLETED') {
      const response = await axios.post(`${process.env.REACT_APP_MOBILE_BASEURL}/api/billing/create`, {
        // orderId: data.orderID,
        // paymentDetails: details,
        // paymentData: data,
        // amount: amount,
        // paymentMethod: 'paypal'
        course_id: course_id ? course_id : '',
        membership_id: membership_id ? membership_id : '',
        transaction_id: data.orderID,
        amount_paid: amount,
        payment_method: data.paymentSource,
        used_wallet_amount: token?.used_wallet_amount,
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` // If you're using JWT
        }
      });

      if (response.status === 201) {
        // Store payment confirmation in localStorage if needed
        // localStorage.setItem('paymentConfirmation', JSON.stringify(response.data));
        // Redirect to success page
        navigate('/paypal/success');
        // window.href='e2t://com.educate2trade.e2t/open?value=success';
        // window.location.href = 'e2t://com.educate2trade.e2t/open?value=success';

        // var appScheme = 'e2t://com.educate2trade.e2t/open?value=success';
        // var fallbackURL = 'https://yourappstorelink.com';

        // var iframe = document.createElement('iframe');
        // iframe.style.display = 'none';
        // iframe.src = appScheme;
        // document.body.appendChild(iframe);

        // var iframe = document.createElement('iframe');
        // iframe.style.display = 'none';
        // iframe.src = 'e2t://com.educate2trade.e2t/open?value=success';
        // document.body.appendChild(iframe);

        document.getElementById("launchApp").click();

        // setTimeout(function() {
        //   window.location = fallbackURL;
        // }, 2000);

  
        // Fallback setTimeout in case immediate redirect doesn't work
        // setTimeout(() => {
        //   window.location.replace('e2t://com.educate2trade.e2t/open?value=success');
        // }, 100);
      }
    }
    } catch (err) {
      // navigate('e2t://com.educate2trade.e2t/open?value=success');
      // window.location.href = 'e2t://com.educate2trade.e2t/open?value=success';
      navigate('/paypal/success');
      document.getElementById("launchApp").click();
      window.location.href = 'e2t://com.educate2trade.e2t/open?value=success';
  
      // Fallback setTimeout in case immediate redirect doesn't work
      // setTimeout(() => {
      //   window.location.replace('e2t://com.educate2trade.e2t/open?value=success');
      // }, 100);

      // setError(err.response?.data?.message || 'Payment confirmation failed');
      // navigate('com.educate2trade.e2t://open?value=success');
      // window.location.href = 'com.educate2trade.e2t://open?value=success';
      console.error('Payment confirmation error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PayPalScriptProvider options={{ "client-id": "AVa__O4Iqnp12J-pxIQyVZVI-bFXqZHGq2dMRGNBGEzbujK1lrsIkXBy6w812mlenkKm68HqJLieuKDx" }}>
      <div className="paypal-container">
        <h2>Pay with PayPal</h2>
        {error && <div className="error-message">{error}</div>}
        {loading && <div className="loading-message">Processing payment...</div>}
        
        <PayPalButtons
          createOrder={(data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    value: amount,
                  },
                },
              ],
            });
          }}
          onApprove={async (data, actions) => {
            const order = await actions.order.capture();
            handlePaymentSuccess(order, data);
          }}
          onError={(err) => {
            setError('PayPal payment failed. Please try again.');
            console.error('Payment error:', err);
          }}
        />
        <a id="launchApp" href="e2t://com.educate2trade.e2t/open?value=success" style={{display: "none"}}></a>
      </div>
    </PayPalScriptProvider>
    
  );
};

export default PayPalPayment;